module.exports = __webpack_public_path__ + "media/assets/community/logo-osc-ba882933333e00e9b59129d3e4b8f55298cd347fca57126cef19098e3eaaaf1e.png";